// eslint-disable-next-line import/prefer-default-export
export const TABS_SET_ACTIVE = (state, { active, widget }) => ({
  ...state,
  [widget]: active
});
